// src/reading-duration.ts
var emojis = {
  hourglass_done: "\u231B ",
  hourglass_not_done: "\u23F3 ",
  stopwatch: "\u23F1 ",
  clock: "\u{1F552} ",
  watch: "\u231A ",
  timer: "\u23F2 ",
  alarm: "\u23F0 ",
  books: "\u{1F4DA} ",
  open_book: "\u{1F4D6} ",
  closed_book: "\u{1F4D5} ",
  blue_book: "\u{1F4D8} ",
  green_book: "\u{1F4D7} ",
  orange_book: "\u{1F4D9} ",
  notebook: "\u{1F4D3} ",
  notebook_alt: "\u{1F4D4} "
};
function readingDuration(htmlContent, options = {}) {
  const { wordsPerMinute = 200, emoji = true } = options;
  const plainText = htmlContent.replace(/<code>.*?<\/code>/gs, "").replace(/```[^`]+```/gs, "").replace(/<[^>]*>/g, "");
  const words = plainText.split(/\s+/).length;
  const minutes = words / wordsPerMinute;
  const readingTime = Math.ceil(minutes);
  const emojiChoice = typeof emoji === "string" ? emojis[emoji] : emoji ? "\u231B " : "";
  return `${emojiChoice}${readingTime} min read`;
}

// src/index.ts
var src_default = readingDuration;
export {
  src_default as default
};
/*!
 * reading-duration
 * Copyright (c) Mutasim
 * MIT Licensed
*/
/*! 
 *  Assuming an average reader reads around 200-230 words per minute, 
 *  research can be found here: https://scholarwithin.com/average-reading-speed
*/
